import { lazy } from 'react'
import { namedExportToDefaultExport } from 'utils'

const componentName = 'NotFound'

const NotFound = lazy(() =>
  import(
    /* webpackChunkName: "NotFound" */
    'components/NotFound'
  ).then(namedExportToDefaultExport(componentName))
)

export { NotFound }
